// @erp/module-lib/fe · the module's typed edge (DEV-GUIDE-002 §6.3 — per-module
// hc client, NOT one giant hc<AppType> everywhere: that anti-pattern crawls the
// editor and defeats tree-shaking, §10). libApi is hc<LibRoutes> based at
// /api/lib — the mount point the gateway gives createLibRouter — so a call like
// `libApi.patrons.$get()` targets `/api/lib/patrons` with the portal's
// cookie-riding defaults (credentials:'include', @erp/api-client).
//
// `import type` is load-bearing TWICE over:
//   1. Runtime — a VALUE import of '../api' would drag Hono, the repos, the
//      service layer and every handler into the browser bundle. Type-only, it
//      is erased: zero worker code ships (verbatimModuleSyntax keeps us honest).
//   2. The seam — this is the module's M1-style exit criterion: if a lib route
//      leaves the chained expression in api/router.ts (or its response shape
//      drifts), LibRoutes changes and THIS build fails typecheck. One source of
//      truth for the wire, checked at compile time.
//
// Worker TYPES (not code) do reach this file: LibRoutes = ReturnType<typeof
// createLibRouter>, and createLibRouter is generic over `E extends LibEnv`,
// whose Bindings name D1Database/R2Bucket (@cloudflare/workers-types globals).
// Resolving LibRoutes therefore loads api/router.ts's type graph, so the fe
// tsconfig carries `types: ["@cloudflare/workers-types"]` (types only — no
// runtime) + the base's skipLibCheck to mute the DOM/workers-types lib overlap.
// This is strictly leaner than routing through @erp/gateway's AppType, which
// would also drag better-auth's bun:sqlite d.ts (the admin portal's tax).
import type { LibRoutes } from "../api/index.js";
import { createApiClient } from "@erp/api-client";

/** The module-scoped hc client. Screens/queries/mutations import THIS, never a portal-wide client. */
export const libApi = createApiClient<LibRoutes>("/api/lib");
export type LibApi = typeof libApi;
